require('./util')

const xClassCreateType = {
    CCClass: 1,
    func: 2
}

xClass = function (className, ...supers) {
    if (!className || typeof (className) !== 'string') {
        cc.assert(false, 'error class definition!')
    }

    let _cls = { supers: [] }
    for (let i = 0; i < supers.length; i++) {
        let _super = supers[i]
        let superType = typeof (_super)
        if (superType === 'function') {
            if (_super._xClass) {
                _cls.supers.push(_super.prototype)
                // 将第一个xClass类设为super
                if (!_cls['super']) {
                    _cls['super'] = _super.prototype
                }
            } else {
                cc.assert(!_cls.create,
                    `class() - create class ${className} with more than one creating function`)

                let isCCClass = _super.id && ClassManager[_super.id]
                _cls.create = _super

                if (isCCClass) {
                    _cls.createType = xClassCreateType.CCClass
                } else {
                    // if (_super.__create) {
                    //     throw Error('class() - can\'t extends function based class')
                    // }
                    _cls.createType = xClassCreateType.func

                }
            }
        } else {
            throw TypeError(`class() - create class ${className} with invalid super type`)
        }
    }

    let xclass
    if (_cls.createType === xClassCreateType.CCClass) {
        xclass = _cls.create.extend()
        extend(xclass.prototype, ..._cls.supers)
    } else {
        xclass = function xClass() { }
        extend(xclass.prototype, ..._cls.supers)
        xclass._xClass = true
        xclass.super = _cls.super
    }

    xclass.__cname = className
    if (_cls.createType !== 'function' && !xclass.prototype.ctor) {
        xclass.prototype.ctor = $noop
    }

    xclass.new = function (...args) {
        let instance
        if (_cls.createType === xClassCreateType.CCClass) {
            instance = new xclass(...args)
        } else if (_cls.createType === xClassCreateType.func) {
            instance = _cls.create(...args)
            if (!instance) {
                throw new Error('class() - create function should return a object')
            }
            // HACK: 多值返回，可能有问题
            if (isArray(instance)) {
                instance = instance[0]
            }
            // 直接附着在实例上
            extend(instance, xclass.prototype)
        } else {
            instance = Object.create(xclass.prototype)
        }

        instance.class = xclass

        if (_cls.createType !== xClassCreateType.CCClass) {
            if (_cls.createType === xClassCreateType.func) {
                // 防止实例重复调用ctor
                if (xclass.prototype.ctor && xclass.prototype.ctor !== Object.getPrototypeOf(instance).ctor) {
                    xclass.prototype.ctor.apply(instance, args)
                }
            } else {
                instance.ctor && instance.ctor.apply(instance, args)
            }
        }

        return instance
    }


    xclass.create = xclass.new

    xclass.prototype.is = function (cls) {
        if (!cls) {
            return false
        }
        return this instanceof cls
    }

    return xclass
}
